import { useEffect } from 'react';
import { classValidatorResolver } from '@hookform/resolvers/class-validator';
import { CompanyUserDataDto } from '../../../../services/sign-up/dto/createSignUpDto';

import { useTranslation } from '@bcba/react-hooks';
import {
  SignupFormState,
  useSignupFormContext,
} from '../../context/useSignUpContext';
import { FormStep } from '../utils/form-step.interface';
import { useForm } from '@agrotoken-tech/ui';
import { isAdminUserAvailable } from '../../../../services/public/isAdminUserAvailable';

const resolver = classValidatorResolver(CompanyUserDataDto);

export const useSecondStepForm = (props: FormStep) => {
  const { setStep } = props;
  const { formState, updateForm, setIsDirty } = useSignupFormContext();
  const formMethods = useForm({ resolver, defaultValues: formState });
  const { t } = useTranslation();
  const {
    handleSubmit,
    clearErrors,
    setError,
    formState: rhfState,
  } = formMethods;

  const submitHandler = async (data: SignupFormState) => {
    const isValidAdminUser = await isAdminUserAvailable(
      data.userEmail ?? '',
      data.userFiscalId ?? '',
    );

    const { emailIsAvailable, fiscalIdIsAvailable } = isValidAdminUser;

    if (!emailIsAvailable) {
      setError('userEmail', {
        type: 'custom',
        message: t(
          'businessSignUp.secondStep.error.adminUserEmailAlreadyExists',
        ),
      });
    } else {
      clearErrors('userEmail');
    }

    if (!fiscalIdIsAvailable) {
      setError('userFiscalId', {
        type: 'custom',
        message: t(
          'businessSignUp.secondStep.error.adminUserFiscalIdAlreadyExists',
        ),
      });
    } else {
      clearErrors('userFiscalId');
    }

    if (!emailIsAvailable || !fiscalIdIsAvailable) return;

    updateForm({ formState: { ...formState, ...data } });
    setStep(3);
  };

  useEffect(() => {
    if (Object.keys(rhfState.dirtyFields).length > 0) {
      setIsDirty(true);
    }
  }, [rhfState.dirtyFields, setIsDirty]);

  return {
    handleSubmit,
    submitHandler,
    formMethods,
  };
};
